import styles from "./InlineSpinner.module.css";

const InlineSpinner = () => {
  return (
    <div className={`d-flex w-100 justify-content-center ${styles.wrap}`}>
      <span className={styles.spinner} role="status" aria-label="Loading" />
    </div>
  );
};

export default InlineSpinner;
